/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSlideshow = /* GraphQL */ `
  mutation CreateSlideshow(
    $input: CreateSlideshowInput!
    $condition: ModelSlideshowConditionInput
  ) {
    createSlideshow(input: $input, condition: $condition) {
      id
      name
      flies
      owner
      createdAt
      updatedAt
    }
  }
`;
export const updateSlideshow = /* GraphQL */ `
  mutation UpdateSlideshow(
    $input: UpdateSlideshowInput!
    $condition: ModelSlideshowConditionInput
  ) {
    updateSlideshow(input: $input, condition: $condition) {
      id
      name
      flies
      owner
      createdAt
      updatedAt
    }
  }
`;
export const deleteSlideshow = /* GraphQL */ `
  mutation DeleteSlideshow(
    $input: DeleteSlideshowInput!
    $condition: ModelSlideshowConditionInput
  ) {
    deleteSlideshow(input: $input, condition: $condition) {
      id
      name
      flies
      owner
      createdAt
      updatedAt
    }
  }
`;
